<form class="input-form">
    <fieldset
        class="fieldset"
        [ngClass]="{ error: hasErrorString() && !disabledTextarea }"
        [class.focus]="isFocus">
        <div
            class="legend"
            [class.error]="hasErrorString() && !disabledTextarea"
            [class.focus]="isFocus">
            {{ inputValue || isFocus ? (legend | translate) : ' ' }}
        </div>
        <textarea
            [disabled]="disabledTextarea"
            class="textarea"
            data-cy="text-area-field"
            [rows]="rows"
            [(ngModel)]="inputValue"
            (input)="checkInputErrors()"
            [ngModelOptions]="{ standalone: true }"
            [placeholder]="!isFocus ? (legend ?? '' | translate) : placeholder ? (placeholder | translate) : (legend | translate)"
            (focus)="inputFocus()"
            (blur)="inputBlur()"
            [maxlength]="maxLength"
            [class.placeholder]="isFocus && placeholder && !inputValue"></textarea>
    </fieldset>
</form>
<ng-container *ngIf="(hasErrorString() || hasCounter) && !disabledTextarea">
    <div
        *ngIf="hasErrorString()"
        class="error-message"
        data-cy="text-area-error-message"
        [class.strong-border]="isStrongBorder">
        {{ getErrorString() }}
    </div>
    <div *ngIf="hasCounter" class="counter-text">
        {{ (inputValue?.length ?? 0) + '/' + maxLength }}
    </div>
</ng-container>
